module.exports = __webpack_public_path__ + "static/dmon-011-3a911529e2a06f6c145074d33a679fc3.jpg";